import { Routes, Route, Navigate } from "react-router-dom";
import routes from "../../routes";
import FixedPlugin from "../../components/fixedPlugin/FixedPlugin";

export default function Auth() {
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return <Route path={`/${prop.path}`} element={prop.component} key={key} />;
      }
      return null;
    });
  };

  // Layout full-bleed: cada página de auth (ex.: SignIn) controla o próprio
  // visual em tela cheia. O toggle de tema continua disponível e flutuante.
  return (
    <div className="min-h-dvh w-full bg-white dark:bg-[#070710]">
      <FixedPlugin />
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
      </Routes>
    </div>
  );
}
